import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

// Paste your firebaseConfig object here
const firebaseConfig = {
  apiKey: "AIzaSyC4i6d7PEO0wxKbliLexAGUdvam6pJA_0g",
  authDomain: "dataportal-7849a.firebaseapp.com",
  projectId: "dataportal-7849a",
  storageBucket: "dataportal-7849a.firebasestorage.app",
  messagingSenderId: "707249676532",
  appId: "1:707249676532:web:9249d609c78e52bd327ea1",
  measurementId: "G-0QPLVWEN1B"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
// Bump the default Storage retry windows. GoPro videos are large and the
// SDK defaults (10 min upload / 2 min operation) can time out on flaky
// connections or backgrounded tabs, surfacing as
// `storage/retry-limit-exceeded`. These give the SDK a much wider
// recovery budget before it gives up on a stalled chunk.
storage.maxUploadRetryTime = 30 * 60 * 1000;     // 30 min (was 10)
storage.maxOperationRetryTime = 5 * 60 * 1000;   // 5 min (was 2)

export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

